// route - sys
const SysRole = r => require.ensure([], () => r(require('@/admin/sys/role.vue')), 'route-sys');
const SysRoleDepart = r => require.ensure([], () => r(require('@/admin/sys/role-depart.vue')), 'route-sys');
const SysModule = r => require.ensure([], () => r(require('@/admin/sys/module.vue')), 'route-sys');
const SysOperation = r => require.ensure([], () => r(require('@/admin/sys/operation.vue')), 'route-sys');
// const SysDepartCate = r => require.ensure([], () => r(require('@/admin/sys/depart-cate.vue')), 'route-sys');
const SysDepart = r => require.ensure([], () => r(require('@/admin/sys/depart.vue')), 'route-sys');
const SysDepartEdit = r => require.ensure([], () => r(require('@/admin/sys/depart-edit.vue')), 'route-sys');
// const SysDepartAccount = r => require.ensure([], () => r(require('@/admin/sys/departaccount.vue')), 'route-sys');
const SysEmployee = r => require.ensure([], () => r(require('@/admin/sys/employee.vue')), 'route-sys');
// const SysDepartCheck = r => require.ensure([], () => r(require('@/admin/sys/depart-check.vue')), 'route-sys');
const SysSettingOther = r => require.ensure([], () => r(require('@/admin/sys/setting-other.vue')), 'route-sys');
// const SysFiles = r => require.ensure([], () => r(require('@/admin/files/list.vue')), 'route-sys');
const SysNotice = r => require.ensure([], () => r(require('@/admin/notice/notice.vue')), 'route-sys');
const SysNoticeEdit = r => require.ensure([], () => r(require('@/admin/notice/notice-edit.vue')), 'route-sys');
// route - web
// const WebNav = r => require.ensure([], () => r(require('@/admin/web/nav.vue')), 'route-web');
const WebSetting = r => require.ensure([], () => r(require('@/admin/web/setting.vue')), 'route-web');
const WebLinks = r => require.ensure([], () => r(require('@/admin/web/links.vue')), 'route-web');
const WebSettingOther = r => require.ensure([], () => r(require('@/admin/web/setting-other.vue')), 'route-web');
// const WebCarousel = r => require.ensure([], () => r(require('@/admin/web/carousel.vue')), 'route-web');
// const WebAbout = r => require.ensure([], () => r(require('@/admin/web/about.vue')), 'route-web');
const Logs = r => require.ensure([], () => r(require('@/admin/other/log.vue')), 'route-logs');

// sys Route
const sysRoute = {
  sys: {
    meta: {r:{k:'sys', v:'系统管理', icon:'cubes'}},
    children: [
      {path:'/sys-role', component: SysRole, meta:{r:{k:'role', v:'角色管理'}, issys:true}},
      {path:'/sys-role2', component: SysRoleDepart, name:'sys-role2', props:(route) => {
        return {departid: route.query.departid}
      }, meta:{r:{k:'roledepart', v:'角色管理'}, issys:false}},
      {path:'/sys-module', component: SysModule, meta:{r:{k:'module', v:'权限模块'}, issys:true}},
      {path:'/sys-operation', component: SysOperation, meta:{r:{k:'operation', v:'模块操作'}, issys:true}},
      // {path:'/depart-cate', component: SysDepartCate, meta:{r:{k:'departcate', v:'组织分类'}, issys:true}},
      {path:'/depart-edit', component: SysDepartEdit, name:'depart-edit', props:(route) => {
        return {departid: route.query.departid}
      }, meta:{r:{k:'depart', v:'部门信息'}, issys:false}},
      {path:'/sys-depart', component: SysDepart, name:'sys-depart', meta:{r:{k:'depart', v:'部门管理'}, issys:true}},
      //{path:'/sys-depart', component: SysDepart, meta:{r:{k:'depart', v:'组织管理'}, issys:false}},
      // {path:'/sys-departaccount', component: SysDepartAccount, meta:{r:{k:'departaccount', v:'公司账户'}}},
      // {path:'/sys-departconfig', component: SysDepartConfig, meta:{r:{k:'departconfig', v:'公司设置'}}},
      {path:'/sys-employee', component: SysEmployee, name:'sys-employee', props:(route) => {
          return {departid: route.query.departid}
        }, meta:{r:{k:'employee', v:'帐号管理'}}
      },
      // {path:'/sys-employee', component: SysEmployee, name:'sys-employee', props:(route) => ({departid:route.params.departid, unitid:route.params.unitid, editsys:false}), meta:{r:{k:'employee', v:'旅行社员工'}, issys:false}},
      // {path:'/sys-employee-sys', component: SysEmployee, name:'sys-sysemp', props:(route) => ({departid:route.params.departid, unitid:route.params.unitid, editsys:true}), meta:{r:{k:'sysemp', v:'公司员工'}, issys:true}},
      // {path:'/sys-depart-check', component: SysDepartCheck, meta:{r:{k:'departcheck', v:'入驻审核'}}},
      // {path:'/sys-files', component: SysFiles, meta:{r:{k:'files', v:'文件管理'}, issys:true}},
      {path:'/notice-add', component: SysNoticeEdit, meta:{r:{k:'notice', role:'add', v:'发布公告'}}},
      {path:'/notice', component: SysNotice, name:"notice-list", meta:{r:{k:'notice', v:'公告管理'}}},
      {path:'/notice-edit/:id', component: SysNoticeEdit, name:"notice-edit", props: true, meta:{r:{k:'notice', role:'edit', v:'公告编辑'}, outslide: true}},
      {path:'/sys-setting-other', component: SysSettingOther, meta:{r:{k:'setting', v:'系统设置'}, issys:true}},
      {path:'/logs', component: Logs, meta:{r:{k:'logs', v:'操作日志'}}},
    ]
  },
  web: {
    meta: {r:{k:'web', v:'网站设置', icon:'cog'}},
    children: [
      // {path:'/web-nav', component: WebNav, meta:{r:{k:'nav', v:'导航菜单'}, issys:true}},
      {path:'/web-setting', component: WebSetting, meta:{r:{k:'setting', v:'网站设置'}}},
      {path:'/web-links', component: WebLinks, meta:{r:{k:'links', v:'友情链接'}}},
      {path:'/web-setting-other', component: WebSettingOther, meta:{r:{k:'other', v:'首页设置'}, issys:true}},
      // {path:'/web-carousel', component: WebCarousel, meta:{r:{k:'carousel', v:'轮播大图'}, issys:true}},
      // {path:'/web-about', component: WebAbout, meta:{r:{k:'about', v:'关于我们'}, issys:true}}
    ]
  }
}

// route - news
const NewsCate = r => require.ensure([], () => r(require('@/admin/news/news-cate.vue')), 'route-news');
const NewsList = r => require.ensure([], () => r(require('@/admin/news/news.vue')), 'route-news');
const NewsEdit = r => require.ensure([], () => r(require('@/admin/news/news-edit.vue')), 'route-news');
const NewsSingle = r => require.ensure([], () => r(require('@/admin/news/news-single.vue')), 'route-news');
const NewsSingleEdit = r => require.ensure([], () => r(require('@/admin/news/news-single-edit.vue')), 'route-news');
const Tougao = r => require.ensure([], () => r(require('@/admin/news/tougao.vue')), 'route-news');
const newsRoute = {
  news: {
    meta: {r:{k:'news', v:'内容管理', icon:'newspaper-o'}},
    children: [
      {path:'/news-cate', component: NewsCate, meta:{r:{k:'cate', v:'内容分类'}}},
      {path:'/news-add', component: NewsEdit, name:'news-add', meta:{r:{k:'info', role:'add', v:'添加内容'}}},
      {path:'/news-edit/:id', component: NewsEdit, name:'news-edit', props:true, meta:{r:{k:'info', role:'edit', v:'编辑内容'}, outslide: true}},
      {path:'/news-list', component: NewsList, name:'news-list', meta:{r:{k:'info', v:'内容管理'}}},
      {path:'/news-check', component: NewsList, name:'news-check', props: {ischeck: true}, meta:{r:{k:'check', v:'内容审核'}}},
      {path:'/news-single', component: NewsSingle, name:'news-single', meta:{r:{k:'single', v:'单项内容'}}},
      {path:'/news-single-edit/:id?', component: NewsSingleEdit, name:'news-single-edit', props:true, meta:{r:{k:'single', role:'edit', v:'编辑单项内容'}, outslide: true}},
      {path:'/tougao', component: Tougao, name:'news-tougao', meta:{r:{k:'tougao', v:'投稿排名'}}},
    ]
  }
}

// route - base
// const BaseTgdw = r => require.ensure([], () => r(require('@/admin/base/tgdw.vue')), 'route-base');
const BaseIp = r => require.ensure([], () => r(require('@/admin/base/ip.vue')), 'route-base');

// base Route
const baseRoute = {
  base: {
    meta: {r:{k:'base', v:'基础信息', icon:'signal'}},
    children: [
      // {path:'/base-tgdw', component: BaseTgdw, meta:{r:{k:'tgdw', v:'投稿单位'}}},
      {path:'/base-ip', component: BaseIp, meta:{r:{k:'ip', v:'授权IP'}}},
    ]
  }
}

export default [newsRoute, baseRoute, sysRoute];